
function initAccordion() {
  const acc = document.getElementsByClassName("accordion");
  if (!acc.length)
    return;

  for (let i = 0; i < acc.length; i++) {
    const accHeader = acc[i].querySelector(".accordion__header");
    const accBody = acc[i].querySelector(".accordion__body");
    
    if (!accHeader)
       return;
    
    accHeader.addEventListener("click", function() {
      acc[i].classList.toggle("active");
      setHeightAccBody(accBody);      
    });    
    window.addEventListener("resize", function() {
      setHeightAccBody(accBody);      
    });
  }

  function setHeightAccBody(accBody) {
    if (accBody.style.maxHeight) {
      accBody.style.maxHeight = null;
    } else {
      accBody.style.maxHeight = accBody.scrollHeight + "px";
    }
  }

}